import * as React from 'react';

import { useCallbackRef } from './useCallbackRef';

/**
 * Provides a declarative `setInterval`.
 *
 * @param callback the callback to execute at interval
 * @param delay the `setInterval` delay in ms
 */
export function useInterval(callback: () => void, delay: number | null) {
  const fn = useCallbackRef(callback);

  React.useEffect(() => {
    const tick = () => fn();
    let intervalId: number | null = null;

    if (delay !== null) {
      intervalId = window.setInterval(tick, delay);
    }

    return () => {
      if (intervalId) {
        window.clearInterval(intervalId);
      }
    };
  }, [delay, fn]);
}
